/* eslint-disable no-nested-ternary */
import { pushAmbitosNoCelebrados } from '../utils/index';
import { tooltipMapa } from '../utils/index';
import { showTiePartiesColors } from '../resources/constantes.json';
import {
  borderColor,
  color,
  emphasis,
  opacity,
  shadowColor,
} from '../utils/estilosMapa';
import hash from 'object-hash';

const getTiePartyColors = (tieParties, nomenclator) => {
  const cols = tieParties.map(
    ({ codpar }) => nomenclator.partidos[Number(codpar) - 1].color
  );
  return cols;
};

function getData(nDep, amb, nomenclator, camaraSeleccionada, mapOpt) {
  const mapaData = camaraSeleccionada.mapagan
    ? camaraSeleccionada.mapagan
    : camaraSeleccionada.mapacam;
  if (mapaData) {
    let data = mapaData.map((el, i) => {
      const sinVotos = el.vot === '0';
      const esMuniOComu = amb.length > 4;
      const ambNoSeleccionado = false;
      const hayEmpate = el.hayEmpate === '1' && el.mesesc !== '0';
      const c = color(
        sinVotos,
        hayEmpate,
        showTiePartiesColors && hayEmpate && el.amb === amb
          ? getTiePartyColors(
              mapOpt.tiePartiesCalc(camaraSeleccionada.partotabla),
              nomenclator
            )
          : nomenclator.partidos[Number(el.codpar) - 1].color
      );
      return {
        name: el.amb,
        value: mapOpt.valueFormatter(el),
        sinInformacion: el.mesesc === '0',
        label: {
          show: false,
        },
        itemStyle: {
          areaColor: c,
          opacity: opacity(sinVotos, ambNoSeleccionado, esMuniOComu),
          borderColor: borderColor(sinVotos, ambNoSeleccionado, esMuniOComu),
          borderWidth: 2 /* borderWidth(ambNoSeleccionado, esMuniOComu) */,
          shadowColor: shadowColor(sinVotos, !ambNoSeleccionado),
          emphasis: emphasis(
            sinVotos,
            nomenclator.partidos[Number(el.codpar) - 1].color,
            hayEmpate ? c : undefined
          ),
        },
        key: i,
      };
    });

    data = pushAmbitosNoCelebrados(data, nDep, nomenclator, '10');

    return data;
  }
}

function getOptionGanadores(
  _rawData,
  nDep,
  amb,
  nomenclator,
  stateRef,
  isDesktop,
  mapOpt,
  camaraSeleccionada,
  setTooltipProps,
  eleccion
) {
  const data = getData(nDep, amb, nomenclator, camaraSeleccionada, mapOpt);
  const option = {
    baseOption: {
      series: [
        {
          roam: false,
          zoom: 1,
          data,
        },
      ],
      right: 'auto',
      animation: false,
      tooltip: tooltipMapa(stateRef, isDesktop, setTooltipProps),
    },
    _id: hash(data, { ignoreUnknown: true }),
  };
  return option;
}

export { getOptionGanadores };
